import { ArticleHeading1, ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';

import { FC } from 'react';

import { CoworkingProfitBanner } from 'shared/components/StickyCoworkingCard/CoworkingProfitBanner';

import { IInfoCost } from './types';

import * as styles from './InfoCost.css';

export const InfoCost: FC<IInfoCost> = props => {
  const { priceAllPerMonth, priceForWorkplace } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['cost-header']}>
        <ArticleHeading1 as="span" color="black_100" fontWeight="bold">
          {`${numberToPrettyString(priceForWorkplace)} ₽`}
        </ArticleHeading1>
        <ArticleHeading2 as="span" color="black_100" fontWeight="bold">
          /мес. за рабочее место
        </ArticleHeading2>
      </div>
      <div className={styles['cost-for-all-office-container']}>
        <ArticleParagraph1 as="span" color="black_60" fontWeight="normal">
          {`${numberToPrettyString(priceAllPerMonth)} ₽/мес. за весь офис`}
        </ArticleParagraph1>
        <CoworkingProfitBanner containerClassName={styles['coworking-profit-banner-container']} />
      </div>
    </div>
  );
};

InfoCost.displayName = 'InfoCost';
